module.exports = __webpack_public_path__ + "img/list-nested.3eb70ca5.svg";